import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { createFakePostResponder } from '../../test-utils';
import { createCallsApi } from './';
import { CallType } from '../../domain';
export var createCallsApiTestKit = function (parent) {
    var fakeHttp = createHttpTestKit();
    var api = createCallsApi(parent, fakeHttp);
    var testKit = {
        whenGetSearchCalls: function (dto) {
            return createFakePostResponder(fakeHttp, '/callcenter/calls/search')(dto);
        },
        whenGetOverview: function () {
            return createFakePostResponder(fakeHttp, '/callcenter/stats/calls')({ callTypes: [CallType.CALLBACK, CallType.INBOUND] });
        },
        whenSearchPhoneCalls: function (dto) {
            return createFakePostResponder(fakeHttp, '/callcenter/phoneCalls/search')(dto);
        },
        whenAdminSearchPhoneCalls: function (dto) {
            return createFakePostResponder(fakeHttp, '/callcenter/phoneCalls/search/admin')(dto);
        },
        whenGetGroupStats: function (dto) {
            return createFakePostResponder(fakeHttp, '/callcenter/stats/callGroups')(dto);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map